
export const menuItems = [
	{ label: "", href: "/" },
	{ label: "Products" },
	{ label: "Solutions" },
	{ label: "Platforms", href: "/platforms" },
	{ label: "Customers", href: "/customers" },
	{ label: "Company", href: "/company"},
];

export const socialLinks = [
	{ label: "Instagram", href: "/#" },
	{ label: "Twitter", href: "/#" },
	{ label: "LinkedIn", href: "/#" },
];
